import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const TrophyIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 4H18V3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2H7C6.73478 2 6.48043 2.10536 6.29289 2.29289C6.10536 2.48043 6 2.73478 6 3V4H3C2.73478 4 2.48043 4.10536 2.29289 4.29289C2.10536 4.48043 2 4.73478 2 5V8C2 12.31 3.8 14.91 6.82 15C7.26064 15.762 7.86353 16.4176 8.58591 16.9205C9.30829 17.4234 10.1325 17.7612 11 17.91V20H10C9.44772 20 9 20.4477 9 21C9 21.5523 9.44772 22 10 22H14C14.5523 22 15 21.5523 15 21C15 20.4477 14.5523 20 14 20H13V17.91C13.8675 17.7612 14.6917 17.4234 15.4141 16.9205C16.1365 16.4176 16.7394 15.762 17.18 15C20.18 14.9 22 12.3 22 8V5C22 4.73478 21.8946 4.48043 21.7071 4.29289C21.5196 4.10536 21.2652 4 21 4ZM4 8V6H6V12.83C4.22 12.08 4 9.3 4 8ZM18 12.83V6H20V8C20 9.3 19.78 12.08 18 12.83Z"
      fill={color}
    />
  </svg>
);
